<template>
  <v-card flat dense>
    <v-card-title>
      {{ $t('ITEM.EDIT') }} {{ $t('RELATED_COMPANIES.ITEM') }}
      <v-spacer />
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid">
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              :value="name"
              :label="$t('RELATED_COMPANIES.RELATED_TO')"
              disabled
            />
          </v-col>
        </v-row>
        <related-company-form
          v-model="form"
          :errors="errors"
          :action="$options.action"
          @input="emitter"
          @update-prop="updateProp(...arguments)"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-btn depressed color="error" @click="remove">
        {{ $t('BUTTON.DELETE') }}
      </v-btn>
      <confirm-dialog ref="confirm" />
      <v-spacer />
      <v-btn
        depressed
        color="primary"
        :disabled="!valid"
        @click="updateRelatedCompany"
      >
        {{ $t('BUTTON.UPDATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import RelatedCompanyForm from '@/modules/relations/components/forms/RelatedCompanyForm';
import formEditable, { EDIT } from '@/modules/_global/mixins/form-editable';

export default {
  name: 'ShowRelatedCompany',

  components: {
    RelatedCompanyForm,
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog')
  },

  action: EDIT,

  mixins: [formEditable],

  props: {
    name: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      valid: false,
      form: {}
    };
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    updateRelatedCompany() {
      this.$emit('update', { ...this.form });
    },

    remove() {
      this.$refs.confirm
        .open(this.$t('MESSAGE.REALLY_WANT_TO_REMOVE'), null, {
          cancelBtnText: this.$t('BUTTON.CANCEL'),
          agreeBtnText: this.$t('BUTTON.DELETE'),
          agreeBtnColor: 'error'
        })
        .then(confirm => {
          if (confirm) {
            this.$emit('remove');
          }
        });
    }
  }
};
</script>
